<template>
    <div>
        <router-view v-if="$route.params.id"></router-view>
        <List v-else></List>
    </div>
</template>

<script>
    import List from '@/views/booking/List.vue'
    export default {
        components: {
            List
        }
    }
</script>
